export const version = '2.23.5';
//# sourceMappingURL=version.js.map